import { SavedCard } from '../../../modules/store/savedCardsStore';
import { BOUNDLESS_ISSUER_PRODUCT_CODES } from '../WalletSavedCardsSection.constants';

export const hasBoundlessSavedCard = (cards?: SavedCard[]): boolean => {
  if (!cards?.length) return false;

  return cards.some(card => {
    const productCode = card.issuerProductCode?.toUpperCase();
    return productCode ? BOUNDLESS_ISSUER_PRODUCT_CODES.includes(productCode) : false;
  });
};
